/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frost_Free_Activated_By_Network_PartialInputs */



/**
* | output |
* | --- |
* | "Frost-free mode activated by network on some thermostatic heads of the room" |
*
* @param {Frost_Free_Activated_By_Network_PartialInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const frost_free_activated_by_network_partial = /** @type {((inputs?: Frost_Free_Activated_By_Network_PartialInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frost_Free_Activated_By_Network_PartialInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free mode activated by network on some thermostatic heads of the room")
	return /** @type {LocalizedString} */ ("Mode HG activé par réseau sur certaines têtes th de la pièce")
});